import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, CheckCircle2Icon } from 'lucide-react';
const tomos = [{
  num: '1',
  color: 'bg-green-500',
  borderColor: 'border-green-500',
  title: 'Clásico Renovado',
  classes: '8+ clases',
  desc: 'Mat, respiración, core, movilidad vertebral y flexibilidad profunda.',
  details: ['Fundamentos del método Pilates clásico actualizados', 'Trabajo de respiración y conexión mente-cuerpo', 'Core profundo: activación, estabilización y control', 'Movilidad vertebral segmento por segmento', 'Flexibilidad funcional con progresión real', '8+ clases completas listas para dar']
}, {
  num: '2',
  color: 'bg-yellow-400',
  borderColor: 'border-yellow-400',
  title: 'Pilates Force',
  classes: '10 clases',
  desc: 'Entrenamiento con bandas elásticas y pesas livianas. Fuerza con conciencia.',
  details: ['Trabajo con bandas elásticas de distintas resistencias', 'Integración de pesas livianas al repertorio', 'Fuerza funcional con control y conciencia corporal', 'Progresión de carga por nivel', '10 clases completas con ejercicios detallados', 'Cueings específicos para trabajo con elementos']
}, {
  num: '3',
  color: 'bg-orange-500',
  borderColor: 'border-orange-500',
  title: 'Flow Dinámico',
  classes: '10 clases',
  desc: 'Transiciones fluidas y movimiento continuo. Desde el primer flow hasta 45 minutos sin pausa.',
  details: ['Transiciones fluidas entre ejercicios', 'Secuencias de movimiento continuo', 'Desde flow básico hasta 45 min sin pausa', 'Trabajo cardiovascular integrado al Pilates', '10 clases con progresión de fluidez', 'Música y ritmo como herramienta de clase']
}, {
  num: '4',
  color: 'bg-red-500',
  borderColor: 'border-red-500',
  title: 'Elementos: Small Ball & Aro',
  classes: '10 clases',
  desc: 'Trabajo de precisión con pelota pequeña y Magic Circle. Activa lo que las manos vacías no alcanzan.',
  details: ['Pelota pequeña: activación profunda y propiocepción', 'Magic Circle: resistencia y feedback muscular', 'Ejercicios que activan lo que las manos vacías no alcanzan', 'Variaciones por nivel para cada elemento', '10 clases completas con ambos elementos', 'Guía de compra y alternativas de elementos']
}, {
  num: '5',
  color: 'bg-purple-500',
  borderColor: 'border-purple-500',
  title: 'Pilates Suave',
  classes: '10 clases',
  desc: 'Protocolo de seguridad completo para adultos mayores, movilidad articular y funcionalidad.',
  details: ['Protocolo de seguridad para adultos mayores', 'Movilidad articular progresiva y segura', 'Trabajo funcional adaptado', 'Ejercicios en silla y de pie incluidos', '10 clases con indicaciones de seguridad', 'Ficha de evaluación inicial para adultos mayores']
}, {
  num: '6',
  color: 'bg-gold',
  borderColor: 'border-gold',
  title: 'Full Power',
  classes: '10 clases',
  desc: 'El repertorio avanzado completo de Joseph Pilates y Reformer adaptado al suelo.',
  isStar: true,
  details: ['Repertorio avanzado original de Joseph Pilates', 'Ejercicios de Reformer adaptados al Mat', 'Secuencias de alta intensidad con control total', 'Trabajo de inversiones y equilibrio avanzado', '10 clases del nivel más exigente del sistema', 'La clase final: 75 minutos de repertorio completo']
}];
function TomoAccordion({
  tomo,
  index
}: {
  tomo: (typeof tomos)[0];
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 15
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.4,
    delay: index * 0.05
  }} className={`rounded-xl border-l-4 ${tomo.borderColor} bg-white shadow-sm overflow-hidden`} data-id="element-410">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-4 md:p-5 text-left hover:bg-gray-50/50 transition-colors" data-id="element-411">
        <div className="flex items-center gap-3" data-id="element-412">
          <div className={`w-9 h-9 md:w-10 md:h-10 rounded-full flex items-center justify-center text-white font-bold text-sm md:text-base shadow-sm ${tomo.color}`} data-id="element-413">
            {tomo.isStar ? '⭐' : tomo.num}
          </div>
          <div data-id="element-414">
            <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider block" data-id="element-415">
              TOMO {tomo.num}
            </span>
            <span className="text-sm md:text-base font-bold text-charcoal font-playfair" data-id="element-416">
              {tomo.title}
            </span>
          </div>
        </div>
        <div className="flex items-center gap-2" data-id="element-417">
          <span className="hidden md:inline-block text-xs text-gray-400 font-medium" data-id="element-418">
            {tomo.classes}
          </span>
          <motion.div animate={{
          rotate: isOpen ? 180 : 0
        }} transition={{
          duration: 0.3
        }} data-id="element-419">
            <ChevronDownIcon className="w-5 h-5 text-gray-400" data-id="element-420" />
          </motion.div>
        </div>
      </button>

      <AnimatePresence data-id="element-421">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-422">
            <div className="px-4 pb-4 md:px-5 md:pb-5 border-t border-gray-100" data-id="element-423">
              <p className="text-sm text-gray-600 mt-3 mb-3 leading-relaxed" data-id="element-424">
                {tomo.desc}
              </p>
              <div className="space-y-2" data-id="element-425">
                {tomo.details.map((detail, i) => <div key={i} className="flex items-start gap-2" data-id="element-426">
                    <CheckCircle2Icon className="w-4 h-4 text-sage flex-shrink-0 mt-0.5" data-id="element-427" />
                    <span className="text-xs md:text-sm text-gray-700" data-id="element-428">
                      {detail}
                    </span>
                  </div>)}
              </div>
              <div className="mt-3" data-id="element-429">
                <span className="inline-block px-2.5 py-0.5 bg-sage-50 rounded-full text-[10px] md:text-xs font-semibold text-sage-700" data-id="element-430">
                  {tomo.classes}
                </span>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}
export function TomosSection() {
  return <section className="py-8 md:py-14 bg-offwhite" data-id="element-431">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-432">
        <div className="text-center mb-6 md:mb-10" data-id="element-433">
          <h2 className="text-sm font-bold text-sage uppercase tracking-widest mb-2" data-id="element-434">
            Los 6 Tomos
          </h2>
          <h3 className="text-2xl md:text-4xl font-bold text-charcoal font-playfair" data-id="element-435">
            Para instructoras de Pilates de todos los niveles y enfoques
          </h3>
        </div>

        <div className="space-y-3" data-id="element-436">
          {tomos.map((tomo, index) => <TomoAccordion key={index} tomo={tomo} index={index} data-id="element-437" />)}
        </div>
      </div>
    </section>;
}